module.exports = __webpack_public_path__ + "img/wuxing.99b5f8e3.png";